import {API_URL} from "@/config.tsx";
import {useEffect, useState} from "react";
import {YMaps, Map, GeoObject} from '@pbe/react-yandex-maps';
import {BranchHint} from "@/pages/static/Contacts/conponents/BranchHints.tsx";
import styles from "../ContactsPage.module.scss";
import {Branch} from "./types.ts";

/**
 * Карта на странице контактов
 * @constructor
 */
export const ContactsMap = () => {
    const [branches, setBranches] = useState<Branch[]>([]);
    const [selectedBranch, setSelectedBranch] = useState<Branch | null>(null);
    const [centerMapCoordinates, setCenterMapCoordinates] = useState<[number, number]>([0, 0]);
    const [zoom, setZoom] = useState(5);
    const [showHint, setShowHint] = useState(false);

    const getBranchesList = () => {
        fetch(`${API_URL}/branches_list`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(result => {
                if (result.length > 0) {
                    setCenterMapCoordinates([result[0].latitude, result[0].longitude]);
                }
                setBranches(result);
            })
            .catch(error => {
                console.error('Ошибка при загрузке списка филиалов:', error);
            });
    };

    const changeBranch = (branch: Branch) => {
        setSelectedBranch(branch);
        setCenterMapCoordinates([branch.latitude, branch.longitude]);
        setZoom(14);
        setShowHint(true);
    }

    useEffect(() => {
        getBranchesList();
    }, []);

    return (
        <div id='contactsmap' className={styles.container}>
            <div className="contacts-map-content">
                {
                    showHint && selectedBranch
                        ? <BranchHint branch={selectedBranch} setShowHint={setShowHint}/>
                        : null
                }
                <div className="contacts-map-title-xs">Пункты выдачи</div>
                <div className="contacts-map-left-column">
                    <div className="contacts-map-left-column-title">Пункты выдачи</div>
                    {branches.map(branch => {
                            if (!branch.latitude || !branch.longitude) return;

                            return (
                                <div className="contacts-branch-info" key={branch.id} onClick={() => changeBranch(branch)}
                                     style={selectedBranch && branch.id === selectedBranch.id ? {
                                         border: '1px solid #ce5e02',
                                         borderRadius: 5,
                                     } : {}}>
                                    <div className="contacts-branch-info-title">{branch.address}</div>
                                    <div className="contacts-branch-info-subtitle">{branch.schedule}</div>
                                    <div
                                        className="contacts-branch-info-subtitle">{branch.type === '100sp' ? 'Пункт выдачи  100СП' : ''}</div>
                                </div>
                            )
                        }
                    )}
                </div>
                <div className="contacts-map-right-column">
                    {branches.length ?
                        (<YMaps>
                            <Map
                                state={{
                                    zoom: zoom,
                                    controls: [],
                                    center: centerMapCoordinates,
                                }}
                                width="100%"
                                height={485}
                            >
                                {branches.map(branch => {
                                    if (!branch.latitude || !branch.longitude) return;

                                    return (
                                        <GeoObject
                                            key={branch.id}
                                            geometry={{
                                                type: 'Point',
                                                coordinates: [branch.latitude, branch.longitude],
                                            }}
                                            options={{
                                                iconLayout: 'default#image',
                                                iconImageHref: '/img/map_dog.png',
                                                iconImageSize: (branch.type === '100sp' ? [30, 30] : [40, 40]),
                                                iconImageOffset: (branch.type === '100sp' ? [-15, -15] : [-20, -20]),
                                                preset: 'islands#orangeStretchyIcon',
                                                draggable: false,
                                            }}
                                        />
                                    )
                                })}
                            </Map>
                        </YMaps>) : null}
                </div>
            </div>
        </div>
    );
};
